import React from "react";
import { useState,useEffect} from "react";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import axios from "axios";
import { ToastContainer,toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { url } from "../../../../../../../../../App";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from 'js-cookie';
import "./BRE.css";
import {useParams } from "react-router-dom";

const BRE = () => {
  const { loanid } = useParams();
  const loanId = loanid;
  const [open, setOpen] = React.useState(false);
  const [breData, setBreData] = useState([])
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const { borrowerData } = useBorrowerContext();
  const fetchedBorrowerDetails = borrowerData.borrower;
  const fetchedLoanDetails = borrowerData.loan;
  console.log(fetchedBorrowerDetails);
  console.log(fetchedLoanDetails);

  const mappedLoanId = () => {
      setOpen(true);
    axios
      .post(url + "/bre/fetch/data", {
        token: token,
        email: email,
        borrowerUniqueno:fetchedBorrowerDetails.borrower_uniqueno,
        loanId: loanId
      })
      .then((res) => {
        setOpen(false);
        console.log(res)
        if(res.data.auth===false){
          toast.error(res.data.message);
        }
        else{
          console.log(res.data.bre_data)      
          setBreData(res.data.bre_data)       
        }
      })
      .catch((err) => {
        setOpen(false);
        console.log(err);
      });
  };
  
  useEffect(() => {
    mappedLoanId();
    //eslint-disable-next-line
  }, [loanId]);

  return (
    <div className="obligation-form">
        <hr className="hori-line" />
        <div className="income-container">
          <table className="report-table">
            <thead style={{backgroundColor:'rgb(207, 226, 243)'}}>
              <tr>
                <th style={{border:'1px solid black'}} >S.No.</th>
                <th style={{border:'1px solid black'}}>Rule Name</th>
                <th style={{border:'1px solid black'}}>Value Field</th>
                <th style={{border:'1px solid black'}}>Approval condition</th>
              </tr>
            </thead>
            <tbody>
              {breData?.map((data, index) => (
                  <tr key={index}>
                    <td style={{border:'1px solid black'}}>{index+1}</td>
                    <td style={{border:'1px solid black'}}>{data.ruleName}</td>
                    <td style={{border:'1px solid black'}}>{data.valueField}</td>
                    <td style={{ color: data.approvalCondition ? 'green' : 'red' }}>{data.approvalCondition ? 'Approved' : data?.rejectReason}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default BRE;
